<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button v-if="backRole('CL_8')" type="primary" @click="addCarBtnClick()" size="mini">新增车辆</el-button>
      </div>

      <label class="label-name">所属公司：</label>
      <el-select @change="forceUpdate" size="mini" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <div class="item-input" style="display:inline-block;width:300px;">
        <label>搜索：</label>
        <el-input v-model="filterKey" size="mini" placeholder="你可以搜索车牌号/车辆型号"></el-input>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" border v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="50">
      </el-table-column>
      <el-table-column prop="plateNo" width="80" label="车牌号码">
      </el-table-column>
      <el-table-column prop="xh" label="车辆型号">
      </el-table-column>
      <el-table-column prop="pl" label="排量(L)" width="100" align="center">
      </el-table-column>

      <el-table-column label="车辆预定情况" width="460px">
        <template slot-scope="scope">
          <div class="no-txt" v-if="scope.row.useApplyList.length<1">暂无车辆预定安排</div>
          <el-table v-else :data="scope.row.useApplyList" class="table-in-room">
            <!-- <el-table-column prop="reason" label="用车事由">
            </el-table-column> -->
            <el-table-column label="使用人" width="150px">
              <template slot-scope="scope">
                <user-info :userData='scope.row.creator'></user-info>
              </template>
            </el-table-column>
            <el-table-column label="用车时间">
              <template slot-scope="scope">
                {{ scope.row.startTime +" - "+ scope.row.endTime }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="status" label="状态" width="80px">
            </el-table-column> -->
          </el-table>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="price" label="购置价(万元)" width="90" align="center">
      </el-table-column>
      <el-table-column prop="buyTime" width="100" label="购置时间">
      </el-table-column> -->
      <el-table-column label="车辆负责人" width="160">
        <template slot-scope="scope">
          <user-info :userData='scope.row.fzr'></user-info>
        </template>
      </el-table-column>
      <!-- <el-table-column label="车辆使用人" width="160">
        <template slot-scope="scope">
          <user-info :userData='scope.row.user'></user-info>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="showLog(scope.row)">日志</el-button>
          <el-tooltip class="item" effect="dark" content="编辑该车辆基础资料" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editCarBtnClick(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 使用/外带记录 -->
    <log :logStatus="logStatus" v-on:hideLog="hideLog()" :userData="userData" :logCar="logCar"></log>

    <!-- 添加车辆基础资料 -->
    <div class="pop-room car-edit-pop" v-if="addCarStatus">
      <a href="javascript:;" @click="addCarStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="23">
          <h3 class="title">新增车辆</h3>
          <el-form ref="form" label-width="120px" class="form">
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="车辆类别">
                  <el-select @change="forceUpdate" size="small" v-model="form.type" placeholder="请选择车辆类别">
                    <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车牌号">
                  <el-input size="small" v-model="form.plateNo"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="车辆型号">
                  <el-input size="small" v-model="form.xh"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="排量">
                  <el-input size="small" v-model="form.pl"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="车架号">
                  <el-input size="small" v-model="form.cjh"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发动机号">
                  <el-input size="small" v-model="form.fdjh"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="行驶里程(万公里)">
                  <el-input size="small" v-model="form.xslc"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购置日期">
                  <el-date-picker size="small" v-model="form.buyTime" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择年月">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="出资单位(产权归属)" label-width="132px">
                  <el-select @change="forceUpdate" size="mini" class="organization-select" v-model="form.czdwId"
                    placeholder="请选择所属公司">
                    <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购置价(万元)">
                  <el-input size="small" v-model="form.price"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="使用人">
                  <div class="contact-user-list">
                    <div class="user-item" v-for="user,i in selectUser">
                      <span class="name">{{user.name}}</span>
                      <span @click="deleteUsers(i)" class="iconfont icon-close1"></span>
                    </div>
                  </div>
                  <el-button @click="addUsers(1)" size="mini" type="primary">选择人员</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="selectUser[0]">
                <el-form-item label="使用部门" label-width="132px">
                  <el-input size="small" :disabled="true" v-model="selectUser[0].childDept"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-col :span="12">
                <el-form-item label="车辆负责人">
                  <div class="contact-user-list">
                    <div class="user-item" v-for="user,i in selectLeader">
                      <span class="name">{{user.name}}</span>
                      <span @click="deleteUsers(i)" class="iconfont icon-close1"></span>
                    </div>
                  </div>
                  <el-button @click="addUsers(2)" size="mini" type="primary">选择人员</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="夜间停放地">
                  <el-input size="small" v-model="form.parkPlace"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div class="clear">
              <el-form-item label="保险记录">
                <el-table border :data="form.carInsures" class="car-table" style="width: 100%">
                  <el-table-column label="保险公司">
                    <template slot-scope="scope">
                      <el-input size="small" v-model="scope.row.company"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="保险金额" width="80px">
                    <template slot-scope="scope">
                      <el-input size="small" v-model="scope.row.price"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="保险期限" width="246px">
                    <template slot-scope="scope">
                      <el-date-picker v-model="scope.row.qx" size="small" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </template>
                  </el-table-column>
                  <el-table-column label="保险单号" width="140px">
                    <template slot-scope="scope">
                      <el-input size="small" v-model="scope.row.dh"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button @click="addCarInsures()" size="mini">增加一项</el-button>
              </el-form-item>
            </div>

            <el-form-item label="">
              <el-button @click="addCar()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  import Log from './log'
  export default {
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,

        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    components: {
      UserInfo,
      Log,
    },
    data() {
      return {
        addCarStatus: false,
        typeArr: ['商务车辆', '生产经营保障用车', '工程车辆', '作业车辆'],
        form: {},
        formDefault: {
          depId: "",
          "buyTime": "",
          "carInsures": [{
            "company": "",
            "dh": "",
            "price": "",
            "qx": "",
            "startTime": "",
            "endTime": "",
          }],
          "cjh": "",
          "czdw": "",
          "fdjh": "",
          "fzrId": "",
          "parkPlace": "",
          "pl": "",
          "plateNo": "",
          "price": "",
          "xh": "",
          "xslc": "",
          // 使ajax时候用json方式提交
          json: true,
        },
        selectUser: "",
        selectLeader: "",
        selectType: '',
        formType: 0,

        // 是否显示log
        logStatus: false,
        logCar: "",

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    created() {
      this.form = this.formDefault

      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = _or

      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.getLists()
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 隐藏车辆 Log
      hideLog() {
        this.logStatus = false
      },
      // 显示车辆 Log
      showLog(row) {
        this.logStatus = true
        this.logCar = row
      },
      // 添加Car管理员
      addUsers(type) {
        this.selectType = type

        let _sr = type == 1 ? this.selectUser : this.selectLeader
        this.$store.commit('set_contactSelectArr', _sr)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)
      },
      // 增加车辆保险记录
      addCarInsures() {
        this.form.carInsures.push({
          "company": "",
          "dh": "",
          "price": "",
          "qx": "",
          "startTime": "",
          "endTime": "",
        })
      },
      // 编辑车辆基础资料按钮点击
      editCarBtnClick(row) {
        this.addCarStatus = true
        this.selectUser = ""
        this.selectLeader = ""

        console.log(row)
        this.form = row
        if (row.fzr) {
          this.selectLeader = [row.fzr]
        }
        if (row.user) {
          this.selectUser = [row.user]
        }
        this.form.carInsures = row.insures
        for (var i = 0; i < this.form.carInsures.length; i++) {
          let _item = this.form.carInsures[i]
          if (_item.startTime && _item.endTime) {
            _item.qx = [_item.startTime, _item.endTime]
          }
        }
        this.form.depId = row.department.id
        this.form.czdwId = row.czdw.id
        this.form.json = true
        // this.form.carId = this.form.id

        // this.form.carId = row.id
        // this.form.dlId = row.dl.id
        // this.form.unitId = row.unit.id
        // this.form.name = row.name
        // this.form.spec = row.spec
        this.formType = 1
      },
      // 新增车辆基础资料按钮点击
      addCarBtnClick() {
        this.addCarStatus = true
        this.formType = 0;
        this.form = this.formDefault
        this.selectLeader = ''
        this.selectUser = ''
      },
      // 新增/编辑车辆基础资料
      addCar() {
        let _url = this.formType == 0 ? '/car/add' : '/car/edit?carId=' + this.form.id

        // 循环处理车辆保险信息
        for (var i = 0; i < this.form.carInsures.length; i++) {
          let _item = this.form.carInsures[i]
          if (_item.company && _item.qx) {
            _item.startTime = _item.qx[0]
            _item.endTime = _item.qx[1]
          }
        }

        ajax.post(_url, this.form, (res) => {
          this.addCarStatus = false
          this.$message.success("添加成功")
          this.getLists()
        })
      },
      // 删除车辆基础资料
      deleteCar(row) {
        this.$confirm('此操作将永久删除该车辆, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // ajax.post('/storage/car/del', {
          //   carId: row.id
          // }, (res) => {
          //   this.$message.success("删除车辆成功")
          //   this.getLists()
          // })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.xh.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.plateNo.indexOf(this
                .filterKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/car/list', {
          depId: this.form.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      contactSelectArr() {
        switch (this.selectType) {
          case 1:
            this.selectUser = this.contactSelectArr
            break;
          case 2:
            this.selectLeader = this.contactSelectArr
            break;
        }
      },
      selectLeader() {
        this.form.fzrId = this.selectLeader[0] ? this.selectLeader[0].id : ''
      },
      selectUser() {
        this.form.userId = this.selectUser[0] ? this.selectUser[0].id : ''
      },
      filterKey() {
        this.getFilterData()
      },
      'form.depId'() {
        this.getLists()
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/car/list.vue